export default __webpack_public_path__ + "static/media/yt_nibiru-ep1.38290312.jpg";